/* eslint-disable ember/classic-decorator-hooks */
import EmberObject from '@ember/object';

import FilterConstants from '../../../../filter-constants';
import * as CommonUtils from '../../../../utils/common';

export default class DeliyannisBandPassIdealOpAmp extends EmberObject {
  // Inputs
  r5 = null;
  q0 = null;
  k = null;
  optimization = null;
  algorithm = null;

  // Outputs
  iBias = null;
  gbw = null;
  rOut = null;
  specialGain = 1;
  name = 'ideal';
  rOutOverGBW = FilterConstants.Limits.INFINITY;
  slewRate = 0;

  init() {
    if (
      CommonUtils.isNullOrUndefined(this.r5) ||
      CommonUtils.isNullOrUndefined(this.q0) ||
      CommonUtils.isNullOrUndefined(this.k) ||
      CommonUtils.isNullOrUndefined(this.optimization) ||
      CommonUtils.isNullOrUndefined(this.algorithm)
    ) {
      throw 'Required values are incomplete. Please provide r5, q0, k, optimization, and algorithm';
    }

    this.iBias = this.computeIBias();
    this.gbw = this.computeGbw();
    this.rOut = this.computeROut(this.gbw);
  }

  computeIBias() {
    var dcOutputVoltageFromIBias = this.optimization.opAmpRequirementSpecValues.dcOutputVoltageFromIBias;
    var iBiasResistance = this.r5;
    return dcOutputVoltageFromIBias / iBiasResistance / this.gain;
  }

  computeROut(gbw) {
    return this.rOutOverGBW * gbw;
  }

  computeGbw() {
    var allowedError = this.optimization.opAmpRequirementSpecValues.allowedError;
    var k = this.k;
    var epsilon = (allowedError + 1) * (allowedError + 1) - 1;
    var result = ((2 * this.q0) / (epsilon / this.stageFp)) * (1 / ((1 - k) * (1 - k)));

    return result;
  }
}
